import React from "react";
import { useTranslation } from "react-i18next";
import StandardModal from "@/js/components/shared/StandardModal";
import Checkbox from "../shared/Checkbox";

interface Props {
	open: boolean;
	onClose: () => void;
	onSubmit: () => void;
	disableChatEnableModal: boolean;
	handleCheckbox: (checked: boolean) => void;
}

const ChatEnableModal = ({ open, onClose, onSubmit, disableChatEnableModal, handleCheckbox }: Props): JSX.Element => {
	const { t } = useTranslation();

	return (
		<StandardModal
			size="small"
			header={<div className="ChatEnableModal_title">{t("classroomChat.enableModalTitle")}</div>}
			open={open}
			close={onClose}
		>
			<div className="ChatEnableModal_text">{t("classroomChat.enableModalMessage")}</div>
			<div className="ChatEnableModal_checkbox">
				<Checkbox checked={disableChatEnableModal} label={t("classroomChat.enableModalDontShowAgain")} onChecked={handleCheckbox} />
			</div>
			<button className="ChatEnableModal_button" type="button" onClick={onSubmit}>
				{t("classroomChat.enableModalConfirm")}
			</button>
		</StandardModal>
	);
};

export default ChatEnableModal;
